import React from 'react';
import css from './PlanningDataSection.module.css';
import bgImage from '../../../../assets/Planning-Data-Section.png';

const CheckIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.55 18.2L3.65 12.3L5.075 10.875L9.55 15.35L18.925 5.975L20.35 7.4L9.55 18.2Z" fill="#FF5722"/>
  </svg>
);

const BULLETS = [
  'UK-wide planning data integration',
  'Vetted construction suppliers',
  'Supporting self-builders & developers',
];

const PlanningDataSection = ({ ppRef, onPpRefChange, onStartProject, onContinueAnyway }) => {
  return (
    <section className={css.section}>
      <img src={bgImage} alt="" className={css.bgImage} aria-hidden="true" />
      <div className={css.overlay} />

      <div className={css.content}>
        {/* Heading + bullets */}
        <div className={css.textBlock}>
          <h2 className={css.heading}>Built around real UK planning data</h2>
          <ul className={css.bullets}>
            {BULLETS.map(item => (
              <li key={item} className={css.bulletItem}>
                <CheckIcon />
                <span>{item}</span>
              </li>
            ))}
          </ul>
          <hr className={css.divider} />
        </div>

        {/* CTA — same section, below divider */}
        <div className={css.ctaBlock}>
          <h3 className={css.ctaHeading}>
            Don't wait for approval to start planning your build
          </h3>

          <div className={css.inputRow}>
            <input
              className={css.input}
              type="text"
              placeholder="Planning Portal or Planning Reference Number"
              aria-label="Planning reference"
              value={ppRef || ''}
              onChange={e => onPpRefChange && onPpRefChange(e.target.value)}
            />
            <button type="button" className={css.ctaBtn} onClick={() => onStartProject && onStartProject(ppRef)}>
              Register My Project
            </button>
          </div>

          <p className={css.continueText}>
            Dont have the number?{' '}
            <button
              type="button"
              className={css.continueLink}
              onClick={onContinueAnyway}
            >
              Continue anyway →
            </button>
          </p>
        </div>
      </div>
    </section>
  );
};

export default PlanningDataSection;
